module.exports = __webpack_public_path__ + "img/20200514_154702.7fbfbd5b.jpg";